import { Button, Space } from "antd";
import { BaseChartProps } from "./TemperatureCableChart";
import React, { useCallback, useState } from "react";
import { ChartDatePicker, co2ChartQueryOptions } from "./Co2Chart";
import { RedoOutlined } from "@ant-design/icons";
import dayjs from "dayjs";
import { RangeValue } from "./ChartContainer";
import { useIsFetching, useQuery } from "@tanstack/react-query";
import { binDBKeys } from "src/pages/binOverview/BinCommander";
import { CompressorChart, useCompressorHistoryQueryOptions } from "./CompressorChart";
import { BaseChartQueryOptions, BaseCsv, useAddDefaultAnnotationsToCsv } from "./modehistoryAndFanChangeHistory";
import { CSVLink } from "react-csv";
import { CsvButton } from "./csv/CsvButton";
import { compressorPSIHeader, compressorStatusHeader, timestampHeader } from "./csv/core";
import { formatCompressorStatus } from "./shared";
import { BaseHeaders } from "./csv/types";

export const CompressorCsv = (props: BaseChartQueryOptions) => {
    const compressorQuery = useQuery({...useCompressorHistoryQueryOptions({
        binId: props.binId,
        range: props.range,
    })});

    function flattenToCsv() {

      const headers: BaseHeaders = [timestampHeader, compressorPSIHeader, compressorStatusHeader];

      const data: BaseCsv[] = [];

      compressorQuery.data?.[0]?.data?.forEach((row, i) => {
        const statusFormatted = formatCompressorStatus(compressorQuery.data?.[1]?.data?.[i]?.y!);
        const newRow: BaseCsv = {
            [timestampHeader]: row.x,
            [compressorPSIHeader]: row.y,
            [compressorStatusHeader]: statusFormatted,
        };
          data.push(newRow);
        });
    return {
      headers: headers, data: data
    };
  }



    const data = flattenToCsv();
    const finalCsv = useAddDefaultAnnotationsToCsv({
        baseData: data.data,
        baseHeaders: data.headers,
        binId: props.binId, range: props.range,
    });
    
        return <CsvButton data={finalCsv.data} headers={finalCsv.headers} baseFileName="compressor" />;   
}

export const CompressorChartTab = (props: BaseChartProps) => {

    
    const currentDate = dayjs();
    const priorDate = currentDate.subtract(7, 'days');


    const isControlled = typeof props.value != 'undefined';
    const [internalValue, setIntervalValue] = useState<RangeValue>([priorDate, currentDate]);
    const inprogress = useIsFetching([...binDBKeys.bin(props.binId), "charts"]);

    // Internally, we need to deal with some value. Depending on whether
    // the component is controlled or not, that value comes from its
    // props or from its internal state.

    const value = isControlled ? props.value : internalValue;


    const onDateChange = useCallback((values: RangeValue, formatter?: any) => {
        if (props.onChange) {
            props.onChange(values);
        }
        else {
            setIntervalValue(values);
        }
    }, [props.onChange]);

    return <>
        <div>
            <Space direction="horizontal" wrap>
                <ChartDatePicker startDate={value?.[0]!} endDate={value?.[1]!} onDateRangeChange={onDateChange} />
                <Button type="primary" disabled={inprogress > 0} icon={<RedoOutlined spin={inprogress > 0} />} onClick={() => {
                    onDateChange([value?.[0]!, dayjs()], ['', '']);
                }}>
                </Button>
                <CompressorCsv binId={props.binId} range={value} />

            </Space>

            <div style={{ width: "100%" }}>
                <CompressorChart binId={props.binId} deviceId={props.deviceId} onChange={onDateChange} value={value} />
            </div>
        </div>
    </>
}